export default "__VITE_ASSET__1acbb688__"